export default "__VITE_ASSET__Cr9sZ9s0__"